import { ExportFileResponse } from 'src/modules/me/models/exportFileResponse';
import { ExportFileSearchFilter } from 'src/modules/me/models/exportFilterSearchFilter';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'ExportFile';

export const getAllExportFiles = (searchFilter: ExportFileSearchFilter) => {
  return AxiosInstance.get<PagedResult<ExportFileResponse>>(controller, { params: searchFilter });
};

export const downloadExportFileById = (exportFileId: number, fileType: string) => {
  const endpoint = `${controller}/${exportFileId}/Data`;
  return AxiosInstance.get(endpoint, {
    responseType: 'blob', // VERY IMPORTANT
    headers: { Accept: fileType },
  });
};

// skipErrorToast: vid radering av flera filer visar myExportsDataGrid ett samlat felmeddelande i stället för ett per fil.
export const deleteExportFile = (exportFileId: number) => {
  return AxiosInstance.delete(`${controller}/${exportFileId}`, { skipErrorToast: true });
};
